/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "izolo",
        "-2": "usuku olwandulela olwayizolo",
        "0": "namhlanje",
        "1": "kusasa",
        "2": "usuku olulandela olwakusasa",
        "future": {
          "one": "osukwini olungu-{0} oluzayo",
          "other": "ezinsukwini ezingu-{0} ezizayo"
        },
        "past": {
          "one": "osukwini olungu-{0} olwedlule",
          "other": "ezinsukwini ezingu-{0} ezedlule."
        }
      },
      "day-narrow": {
        "-1": "izolo",
        "-2": "usuku olwandulela olwayizolo",
        "0": "namhlanje",
        "1": "kusasa",
        "2": "usuku olulandela olwakusasa",
        "future": {
          "one": "osukwini olungu-{0} oluzayo",
          "other": "ezinsukwini ezingu-{0} ezizayo"
        },
        "past": {
          "one": "{0} usuku olwedlule",
          "other": "{0} izinsuku ezedlule"
        }
      },
      "day-short": {
        "-1": "izolo",
        "-2": "usuku olwandulela olwayizolo",
        "0": "namhlanje",
        "1": "kusasa",
        "2": "usuku olulandela olwakusasa",
        "future": {
          "one": "osukwini olungu-{0} oluzayo",
          "other": "ezinsukwini ezingu-{0} ezizayo"
        },
        "past": {
          "one": "{0} usuku olwedlule",
          "other": "{0} izinsuku ezedlule"
        }
      },
      "hour": {
        "0": "leli hora",
        "future": {
          "one": "ehoreni elingu-{0} elizayo",
          "other": "emahoreni angu-{0} ezayo"
        },
        "past": {
          "one": "{0} ihora eledlule",
          "other": "emahoreni angu-{0} edlule"
        }
      },
      "hour-narrow": {
        "0": "leli hora",
        "future": {
          "one": "ehoreni elingu-{0} elizayo",
          "other": "emahoreni angu-{0} ezayo"
        },
        "past": {
          "one": "{0} ihora eledlule",
          "other": "{0} amahora edlule"
        }
      },
      "hour-short": {
        "0": "leli hora",
        "future": {
          "one": "ehoreni elingu-{0} elizayo",
          "other": "emahoreni angu-{0} ezayo"
        },
        "past": {
          "one": "{0} ihora eledlule",
          "other": "emahoreni angu-{0} edlule"
        }
      },
      "minute": {
        "0": "leli minithi",
        "future": {
          "one": "kuminithi elingu-{0} elizayo",
          "other": "kumaminithi angu-{0} ezayo"
        },
        "past": {
          "one": "{0} iminithi eledlule",
          "other": "{0} amaminithi edlule"
        }
      },
      "minute-narrow": {
        "0": "leli minithi",
        "future": {
          "one": "kuminithi elingu-{0} elizayo",
          "other": "kumaminithi angu-{0} ezayo"
        },
        "past": {
          "one": "{0} iminithi eledlule",
          "other": "{0} amaminithi edlule"
        }
      },
      "minute-short": {
        "0": "leli minithi",
        "future": {
          "one": "kuminithi elingu-{0} elizayo",
          "other": "kumaminithi angu-{0} ezayo"
        },
        "past": {
          "one": "{0} iminithi eledlule",
          "other": "{0} amaminithi edlule"
        }
      },
      "month": {
        "-1": "inyanga edlule",
        "0": "le nyanga",
        "1": "inyanga ezayo",
        "future": {
          "one": "enyangeni engu-{0}",
          "other": "ezinyangeni ezingu-{0} ezizayo"
        },
        "past": {
          "one": "{0} inyanga edlule",
          "other": "{0} izinyanga ezedlule"
        }
      },
      "month-narrow": {
        "-1": "inyanga edlule",
        "0": "le nyanga",
        "1": "inyanga ezayo",
        "future": {
          "one": "enyangeni engu-{0} ezayo",
          "other": "enyangeni engu-{0} ezayo"
        },
        "past": {
          "one": "{0} izinyanga ezedlule",
          "other": "{0} izinyanga ezedlule"
        }
      },
      "month-short": {
        "-1": "inyanga edlule",
        "0": "le nyanga",
        "1": "inyanga ezayo",
        "future": {
          "one": "ezinyangeni ezingu-{0} ezizayo",
          "other": "ezinyangeni ezingu-{0} ezizayo"
        },
        "past": {
          "one": "{0} izinyanga ezedlule",
          "other": "{0} izinyanga ezedlule"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ikota edlule",
        "0": "le kota",
        "1": "ikota ezayo",
        "future": {
          "one": "kwikota engu-{0} ezayo",
          "other": "kumakota angu-{0} ezayo"
        },
        "past": {
          "one": "{0} ikota edlule",
          "other": "{0} amakota adlule"
        }
      },
      "quarter-narrow": {
        "-1": "ikota edlule",
        "0": "le kota",
        "1": "ikota ezayo",
        "future": {
          "one": "kumakota angu-{0}",
          "other": "kumakota angu-{0}"
        },
        "past": {
          "one": "{0} amakota adlule",
          "other": "{0} amakota edlule"
        }
      },
      "quarter-short": {
        "-1": "ikota edlule",
        "0": "le kota",
        "1": "ikota ezayo",
        "future": {
          "one": "kwikota engu-{0} ezayo",
          "other": "kumakota angu-{0} ezayo"
        },
        "past": {
          "one": "{0} amakota adlule",
          "other": "{0} amakota edlule"
        }
      },
      "second": {
        "0": "manje",
        "future": {
          "one": "kusekhondi elingu-{0} elizayo",
          "other": "kumasekhondi angu-{0} ezayo"
        },
        "past": {
          "one": "{0} isekhondi eledlule",
          "other": "{0} amasekhondi edlule"
        }
      },
      "second-narrow": {
        "0": "manje",
        "future": {
          "one": "kusekhondi elingu-{0} elizayo",
          "other": "kumasekhondi angu-{0} ezayo"
        },
        "past": {
          "one": "{0} isekhondi eledlule",
          "other": "{0} amasekhondi edlule"
        }
      },
      "second-short": {
        "0": "manje",
        "future": {
          "one": "kusekhondi elingu-{0} elizayo",
          "other": "kumasekhondi angu-{0} ezayo"
        },
        "past": {
          "one": "{0} isekhondi eledlule",
          "other": "{0} amasekhondi edlule"
        }
      },
      "week": {
        "-1": "iviki eledlule",
        "0": "leli viki",
        "1": "iviki elizayo",
        "future": {
          "one": "evikini elingu-{0}",
          "other": "emavikini angu-{0}"
        },
        "past": {
          "one": "evikini elingu-{0} eledlule",
          "other": "amaviki angu-{0} edlule"
        }
      },
      "week-narrow": {
        "-1": "iviki eledlule",
        "0": "leli viki",
        "1": "iviki elizayo",
        "future": {
          "one": "emavikini angu-{0} ezayo",
          "other": "emavikini angu-{0} ezayo"
        },
        "past": {
          "one": "amaviki angu-{0} edlule",
          "other": "amaviki angu-{0} edlule"
        }
      },
      "week-short": {
        "-1": "iviki eledlule",
        "0": "leli viki",
        "1": "iviki elizayo",
        "future": {
          "one": "evikini elingu-{0} elizayo",
          "other": "emavikini angu-{0} ezayo"
        },
        "past": {
          "one": "amaviki angu-{0} edlule",
          "other": "amaviki angu-{0} edlule"
        }
      },
      "year": {
        "-1": "onyakeni odlule",
        "0": "kulo nyaka",
        "1": "unyaka ozayo",
        "future": {
          "one": "onyakeni ongu-{0} ozayo",
          "other": "eminyakeni engu-{0} ezayo"
        },
        "past": {
          "one": "{0} unyaka odlule",
          "other": "{0} iminyaka edlule"
        }
      },
      "year-narrow": {
        "-1": "onyakeni odlule",
        "0": "kulo nyaka",
        "1": "unyaka ozayo",
        "future": {
          "one": "onyakeni ongu-{0} ozayo",
          "other": "eminyakeni engu-{0} ezayo"
        },
        "past": {
          "one": "{0} unyaka odlule",
          "other": "{0} unyaka odlule"
        }
      },
      "year-short": {
        "-1": "onyakeni odlule",
        "0": "kulo nyaka",
        "1": "unyaka ozayo",
        "future": {
          "one": "onyakeni ongu-{0} ozayo",
          "other": "eminyakeni engu-{0} ezayo"
        },
        "past": {
          "one": "{0} unyaka odlule",
          "other": "{0} unyaka odlule"
        }
      }
    },
    "locale": "zu"
  });
}